// Single source of truth for business content
export const BUSINESS = {
    name: "Aekkarag Thai Massage",
    tagline: "Experience True Thai Wellness",
    email: "aekkaragthaimassage@gmail.com",
    facebook: "https://www.facebook.com/p/Aekkarag-Thai-Massage-61571812110231/",
};

export const BRANCHES = [
    {
        id: "claremont",
        name: "Claremont",
        label: "Aekkarag Thai Massage",
        address: "90 Imam Haron Rd, Claremont, Cape Town, 7735",
        phone: "067 371 7074",
        phoneRaw: "+27673717074",
        whatsapp: "27673717074",
        hours: "Mon – Sun · 9:00 AM – 7:00 PM",
        mapsEmbed:
            "https://www.google.com/maps?q=90+Imam+Haron+Rd,+Claremont,+Cape+Town,+7735&output=embed",
        mapsLink:
            "https://www.google.com/maps/search/?api=1&query=90+Imam+Haron+Rd,+Claremont,+Cape+Town",
    },
    {
        id: "wynberg",
        name: "Wynberg",
        label: "Aekkarag Thai Massage 2",
        address: "96 Batts Rd, Wynberg, Cape Town, 7800",
        phone: "068 500 6722",
        phoneRaw: "+27685006722",
        whatsapp: "27685006722",
        hours: "Mon – Sun · 9:30 AM – 7:00 PM",
        mapsEmbed:
            "https://www.google.com/maps?q=96+Batts+Rd,+Wynberg,+Cape+Town,+7800&output=embed",
        mapsLink:
            "https://www.google.com/maps/search/?api=1&query=96+Batts+Rd,+Wynberg,+Cape+Town",
    },
];

// Pricing matrix — durations 30 / 45 / 60 / 90 minutes
export const DURATIONS = ["30 min", "45 min", "60 min", "90 min"];

export const SERVICES = [
    {
        id: "thai-oil",
        name: "Thai Oil Massage",
        icon: "Droplet",
        blurb:
            "Warm aromatic oils glide over the body in long, flowing strokes — releasing tension and restoring deep calm.",
        prices: [350, 400, 450, 600],
    },
    {
        id: "aromatherapy",
        name: "Aromatherapy",
        icon: "Flower2",
        blurb:
            "Hand-blended essential oils paired with gentle Thai pressure to soothe the senses and quiet a busy mind.",
        prices: [350, 400, 450, 600],
    },
    {
        id: "sports",
        name: "Sports Massage",
        icon: "Activity",
        blurb:
            "Deeper, targeted work for tired muscles. Ideal for athletes, runners and anyone carrying knots.",
        prices: [400, 450, 550, 650],
    },
    {
        id: "back-neck-shoulder",
        name: "Back, Neck & Shoulder",
        icon: "MoveHorizontal",
        blurb:
            "Focused relief where modern life lives — the desk-tight upper back, neck and shoulder line.",
        prices: [350, 400, 450, 600],
    },
    {
        id: "head-neck",
        name: "Head & Neck",
        icon: "Sparkles",
        blurb:
            "Slow, intentional work along the scalp and neck to ease headaches and dissolve daily strain.",
        prices: [350, 400, 450, 600],
    },
    {
        id: "thai-original",
        name: "Thai Original Massage",
        icon: "Leaf",
        blurb:
            "The traditional dry massage of Thailand — rhythmic compressions, stretches and pressure-line work.",
        prices: [350, 400, 450, 600],
    },
    {
        id: "reflexology",
        name: "Reflexology · Foot Massage",
        icon: "Footprints",
        blurb:
            "An ancient pressure-point treatment for the feet that quiets the whole body and improves circulation.",
        prices: [350, 400, 450, 600],
    },
];

export const REASONS = [
    {
        title: "Skilled Thai therapists",
        text: "Trained in authentic Thai techniques with years of in-room experience.",
        icon: "BadgeCheck",
    },
    {
        title: "Authentic Thai techniques",
        text: "Traditional pressure-line work, stretches and warm-oil therapies — done the right way.",
        icon: "Lotus",
    },
    {
        title: "Relaxing atmosphere",
        text: "Soft light, warm scents and a calm, private space designed to slow you down.",
        icon: "Candle",
    },
    {
        title: "Caring service",
        text: "Friendly, attentive and never rushed — every session is shaped to how you feel.",
        icon: "Heart",
    },
    {
        title: "Stress & wellness focus",
        text: "Therapies that go beyond the body — relief for tension, sleep and overall wellbeing.",
        icon: "Sun",
    },
];

export const REVIEW = {
    quote:
        "Anna, a Thai massage therapist at Aekkarag Thai Massage, gives very good advice and her massage is truly impressive. I go there three times a month and have never been disappointed.",
    author: "Tomas L.",
    rating: 5,
};

// Image gallery (user uploads + curated stock)
export const GALLERY = [
    {
        url: "https://customer-assets.emergentagent.com/job_852eb7a7-740b-414f-96f5-1ef7a367cc9e/artifacts/eg8zhvet_680695666_122157885278727070_7418741719860841371_n.jpg",
        alt: "Aekkarag Thai therapist in traditional dress",
        span: "row-span-2",
    },
    {
        url: "https://customer-assets.emergentagent.com/job_852eb7a7-740b-414f-96f5-1ef7a367cc9e/artifacts/hv4ar672_686882812_122158264874727070_802162192500689436_n.jpg",
        alt: "Aekkarag Thai Massage Claremont storefront on Imam Haron Rd",
    },
    {
        url: "https://images.unsplash.com/photo-1728497872660-cc6b16238c3a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        alt: "Reflexology foot massage",
    },
    {
        url: "https://customer-assets.emergentagent.com/job_852eb7a7-740b-414f-96f5-1ef7a367cc9e/artifacts/s4jk7f4b_475360942_122107039796727070_9110641179054255424_n.jpg",
        alt: "Aekkarag Thai Massage signage and offerings",
    },
    {
        url: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        alt: "Spa stones and candle",
    },
    {
        url: "https://images.unsplash.com/photo-1600334129128-685c5582fd35?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        alt: "Calm spa interior",
        span: "col-span-2",
    },
    {
        url: "https://images.unsplash.com/photo-1581514439794-f9777f7c22eb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        alt: "Aromatherapy essential oils",
    },
    {
        url: "https://images.unsplash.com/photo-1540555700478-4be289fbecef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        alt: "Massage therapist working on shoulders",
    },
];

export const HERO_IMAGE =
    "https://images.unsplash.com/photo-1600334129128-685c5582fd35?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export const ABOUT_IMAGE =
    "https://images.unsplash.com/photo-1591343395082-e120087004b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

// Helper builders
export const waLink = (whatsapp, msg = "Hi, I would like to book a Thai massage.") =>
    `https://wa.me/${whatsapp}?text=${encodeURIComponent(msg)}`;

export const telLink = (phone) => `tel:${phone}`;
